export function register(updateCallback?: () => void): void {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/serviceWorker.js')
        .then((registration) => {
          console.log('✅ Service Worker registered:', registration);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker) {
              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('🔄 New content available');
                  if (updateCallback) updateCallback();
                }
              };
            }
          };
        })
        .catch((error) => {
          console.error('❌ SW registration failed:', error);
        });
    });
  }
}
